function waitForAnimationFrame(): Promise<void> {
  return new Promise(resolve => {
    requestAnimationFrame(() => resolve());
  });
}

async function waitForImages(): Promise<void> {
  const imageElements = Array.from(document.images);
  await Promise.all(
    imageElements.map(async image => {
      if (image.complete) {
        return;
      }

      if (typeof image.decode === 'function') {
        try {
          await image.decode();
          return;
        } catch {
          // Fall back to load/error listeners when decode is not reliable.
        }
      }

      await new Promise<void>(resolve => {
        const handleDone = () => {
          image.removeEventListener('load', handleDone);
          image.removeEventListener('error', handleDone);
          resolve();
        };

        image.addEventListener('load', handleDone, { once: true });
        image.addEventListener('error', handleDone, { once: true });
      });
    }),
  );
}

export async function waitForRenderAssets(): Promise<void> {
  if ('fonts' in document) {
    await document.fonts.ready;
  }

  await waitForImages();
  await waitForAnimationFrame();
  await waitForAnimationFrame();
}
